var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "gobierto-vue-dropdown" }, [
    _c(
      "div",
      {
        staticClass: "gobierto-vue-dropdown--trigger",
        on: { click: _vm.show }
      },
      [_vm._t("trigger")],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "gobierto-vue-dropdown--content" },
      [
        _c(
          "transition",
          { attrs: { name: "slide" } },
          [_vm.isContentVisible ? _vm._t("default") : _vm._e()],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }